const convertImageFormat = (imageUrl, imageFormat) => new Promise((resolve, reject) => {
    if (!imageUrl)
        reject(new Error('Image url is empty'));
    const img = new Image();
    img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL(imageFormat));
        }
        else {
            reject(new Error('Could not get canvas context'));
        }
    };
    img.onerror = () => reject(new Error('Image failed to load'));
    img.src = imageUrl;
});
export default convertImageFormat;
